import Util from '@/lib/util'
export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width: 80,
      },
    {
        title:Util.L('Code'),
        key:'code'
    },
    {
        title:Util.L('Type'),
        key:'transportTypeName'
    },
    {
        title:Util.L('Status'),
        key:'statusName'
    },
    {
        title:Util.L('LastModificationTime'),
        key:'lastModificationTime',
        render:(h:any,params:any)=>{
            if(!Util.isNull(params.row.lastModificationTime))
                return h("span", Util.toViewDateString(params.row.lastModificationTime));
                return h("span", "");
        }
    },
    {
        title: Util.L('Action'),
        slot: 'action',
        align: 'center',
        width: 100
    }]